import _ from 'lodash'

export const FETCHING_MYD_COMPETENCES = 'FETCHING_MYD_COMPETENCES'
export const FETCHED_MYD_COMPETENCES = 'FETCHED_MYD_COMPETENCES'
export const FETCHING_MYD_COMPETENCE = 'FETCHING_MYD_COMPETENCE'
export const FETCHED_MYD_COMPETENCE = 'FETCHED_MYD_COMPETENCE'
export const FETCHING_MYD_COMPETENCES_USED_IN_ACTIVITIES = 'FETCHING_MYD_COMPETENCES_USED_IN_ACTIVITIES'
export const FETCHED_MYD_COMPETENCES_USED_IN_ACTIVITIES = 'FETCHED_MYD_COMPETENCES_USED_IN_ACTIVITIES'


const mydCompetencesInit = {
  isFetching: false,
  data: [],
  options: [],
}

export function mydCompetences(mydCompetences=mydCompetencesInit, action) {
  switch(action.type) {
    case FETCHING_MYD_COMPETENCES:
      return {
        ...mydCompetencesInit,
        isFetching: true,
      }
    case FETCHED_MYD_COMPETENCES:
      return {
        isFetching: false,
        data: action.mydCompetences,
        options: _.map(
          action.mydCompetences,
          mydCompetence => ({
            text: mydCompetence.title,
            key: `mydCompetence_${mydCompetence.id}`,
            value: mydCompetence.id,
          })
        )
      }
    default:
      return mydCompetences
  }
}


const mydCompetencesUsedInActivitiesInit = {
  isFetching: false,
  data: [],
  options: [],
}

export function mydCompetencesUsedInActivities(
  mydCompetencesUsedInActivities=mydCompetencesUsedInActivitiesInit,
  action,
) {
  switch(action.type) {
    case FETCHING_MYD_COMPETENCES_USED_IN_ACTIVITIES:
      return {
        isFetching: true,
        data: [],
        options: [],
      }
    case FETCHED_MYD_COMPETENCES_USED_IN_ACTIVITIES:
      const options = _.map(
        action.mydCompetences,
        item => ({
          value: item.id,
          text: item.title,
          key: `mydCompetence_${item.id}`,
        })
      )

      return {
        isFetching: false,
        data: action.mydCompetences,
        options,
      }
    default:
      return mydCompetencesUsedInActivities
  }
}
